import { cva } from "class-variance-authority";

export const tagVariants = cva(
  "inline-flex items-center rounded-[var(--radius-full)] px-4 py-2",
  {
    variants: {
      variant: {
        outline: "border border-neutral-300 text-neutral-700",
        soft: "border border-transparent bg-neutral-100 text-neutral-700",
        softInverted: "border border-transparent bg-white text-neutral-700",
      },
    },

    defaultVariants: {
      variant: "outline",
    },
  },
);
